import safeFetch from '../extenstions/safeFetch';
import url from '../extenstions/url';

export default (secret, setStatus) => safeFetch(`${url.tasks.status}?secret=${secret}`)
    .then(setStatus);
